'use client';

import { FC, ReactNode } from 'react';

import '@telialt/utils/src/polyfills/string-replace-all';

import { SessionProlongationModal } from '../SessionProlongationModal/SessionProlongationModal';

type Props = {
    hasSessionProlongation?: boolean;
    children: ReactNode;
};

/**
 * Any generic client side component or hook should go into this component
 */
export const InitClientComponentData: FC<Props> = ({ hasSessionProlongation = true, children }) => {
    return (
        <>
            {children}
            {hasSessionProlongation && <SessionProlongationModal />}
        </>
    );
};
